export const SET_SHOW_MODAL = 'userManagement/SET_SHOW_MODAL';
export const SET_SUCCESS = 'userManagement/SET_SUCCESS';

export const ADD_USER_REQUEST = 'userManagement/ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'userManagement/ADD_USER_LOADING';
export const ADD_USER_FAILURE = 'userManagement/ADD_USER_FAILURE';
